import { logger } from 'src/logger';
import { emitClickMetrics, MetricsName } from 'src/metrics';

export enum LocalStorageKeys {
  CPR_LANGUAGE = 'CPR_LANGUAGE',
  DATA_GRID_FILTER_STATE = 'DATA_GRID_FILTER_STATE',
  DATA_GRID_SORT_STATE = 'DATA_GRID_SORT_STATE',
  SELECTED_ACCOUNT = 'SELECTED_ACCOUNT',
}

export const setLocalStorageItem = (key: LocalStorageKeys, value: string) => {
  try {
    localStorage.setItem(key, value);
  } catch {
    emitClickMetrics(MetricsName.LOCAL_STORAGE, `LocalStorageWriteFailed`);
    logger.info(
      `Local Storage write failed with key : ${key} and value length : ${value.length}`,
    );
  }
};

export const getLocalStorageItem = (key: LocalStorageKeys): string | null => {
  try {
    return localStorage.getItem(key);
  } catch {
    emitClickMetrics(MetricsName.LOCAL_STORAGE, `LocalStorageReadFailed`);
    logger.info(`Local Storage read failed with key : ${key}`);
    return null;
  }
};
